import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { PayTransparencyBanner } from './pay-transparency-banner';
import { usePayTransparencyBannerState } from './use-pay-transparency-banner-state';

// Destination of the CTA: the employer's job positions list, where they can open
// and update a non-compliant ad. Final destination/label follow the Figma design.
const JOB_POSITIONS_ROUTE = '/employer/job-positions';

/**
 * App-wide container for the pay-transparency reminder banner. Self-gating: renders
 * nothing unless the user is a PPU employer with at least one non-compliant published
 * job position and has not snoozed the banner within the last 24h.
 */
export function PayTransparencyBannerContainer() {
  const router = useRouter();
  const { shouldShowBanner, handleDismiss } = usePayTransparencyBannerState();

  const handleCtaClick = useCallback(() => {
    router.push(JOB_POSITIONS_ROUTE);
  }, [router]);

  if (!shouldShowBanner) return null;

  return <PayTransparencyBanner onDismiss={handleDismiss} onCtaClick={handleCtaClick} />;
}

export default PayTransparencyBannerContainer;
